import { AppMaterialModule } from '../../../shared/app-material/app-material.module';
import { Component, inject, Input, signal } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { AsksExpansionPanelComponent } from '../components/asks-expansion-panel/asks-expansion-panel.component';
import { GlobalConfigService } from '../../../core/services/global-config.service';

@Component({
  selector: 'app-frequently-asked-questions',
  standalone: true,
  imports: [SharedModule, AsksExpansionPanelComponent],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FrequentlyAskedQuestionsComponent {
  public globalConfig = inject(GlobalConfigService);

  openChat() {
    window.open(this.globalConfig.getContactNumber().redirectUrl, '_blank');
  }
}
